import { Injectable } from '@angular/core';
import { WorkspacePullStateGridItem } from '@common/workspace/models/workspace-pull-state-grid-item.model';
import { State, Store } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';

@CollectionStateSelectors({
  stateType: CollabPullsState
})
@State<CollabPullsState>({
  name: CollabPullsState.source
})
@Injectable()
export class CollabPullsState extends CollectionStateBase {
  static source: string = 'CollabPulls';
  getSource(): string {
    return CollabPullsState.source;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CollabPullsDataService extends CollectionDataServiceBase<WorkspacePullStateGridItem> {
  constructor(protected store: Store) {
    super(store, CollabPullsState);
  }
}
